import { isMobile, isTablet } from 'react-device-detect';

const Device = {
  isMobile: () => {
    return isMobile && !isTablet;
  },
};
export default Device;
